import { useSelector } from 'react-redux';

import { usePreferences } from '../../react-query/usePreferences';
import { PracticeFeatureFlagKey, useFeatureFlag } from '../user';

export const useIsInsurancePDFEnabled = () => {
  const practice = useSelector((state: any) => state.login?.user?.practice);
  const isDDAIInsurancePDFEnabled = !!useFeatureFlag(
    PracticeFeatureFlagKey.DDAI_INSURANCE_PDF_ENABLED,
  )?.value;
  const { data: prefs } = usePreferences();
  const isClaimsEnabled = prefs?.insSummaryModal && prefs?.cleanClaims;
  const isRealtimeInsurancePDFDisabled = !!useFeatureFlag(
    PracticeFeatureFlagKey.REALTIME_INSURANCE_PDF_DISABLED,
  )?.value;
  const isSalesDemo = !!useFeatureFlag(PracticeFeatureFlagKey.IS_SALES_DEMO)
    ?.value;

  // DO NOT REMOVE THIS CONDITION WHEN RESOLVING MERGE CONFLICTS. Necessary to hide claims button in sales demo.
  if (isRealtimeInsurancePDFDisabled || isClaimsEnabled || isSalesDemo) {
    return false;
  }
  return practice?.configuration !== 'DDAI' || isDDAIInsurancePDFEnabled;
};
